export const isEnvFlagOn = (value?: string) =>
  value === 'enabled' || value === 'on' || value === '1';
